import { SmlsInputText } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { useMemberData } from 'pages/FirstAccessFlow/context/MemberDataContext';
import React, { useEffect, useState } from 'react';

export function AddressCityInput() {
  const { handler, formData, setFormEdit } = useMemberData();
  const [value, setValue] = useState<string>('');
  const { t } = useTranslation('redo-register-v2');

  useEffect(() => {
    setValue(formData.city);
  }, [handler]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormEdit();
  };

  return (
    <SmlsInputText
      textLabel={t('labels.addressCity')}
      disabled={!formData.isForeign}
      onChange={handleChange}
      value={value}
      data-testid="first-access-address-city-input"
    />
  );
}
